import { createStateSelectorHook } from 'src/lib/sweetState';

import { UiStore } from './UiStore';

export const useHubspotWidgetStatus = createStateSelectorHook(UiStore, ['hubspotWidgetVisible']);
